import { NoteType } from '../../../enums/NoteType'
import Note from '../../Note'
import BooleanSearchHelpContent from '../../BooleanSearchHelpContent'

export default function HelixBooleanSearchHelp() {
    return (
        <div className="mt-2">
            <Note
                type={NoteType.INFO}
                containerClassNames="bg-white p-2 rounded-lg"
            >
                <BooleanSearchHelpContent />
            </Note>
        </div>
    )
}
